import React from 'react';
import ProtectedRoute from './ProtectedRoutes';

// ── Quantity Surveyor ────────────────────────────────────────────────────────
export const QsProtectedRoute = ({ children }) => (
    <ProtectedRoute
        departments={['MPCU-QS']}
        roles={['quantity_surveyor', 'department_head', 'super_admin', 'system_admin']}
        permissions={[
            'certificates.review_qs',
            'certificates.approve_qs',
            'certificates.create',
            'certificates.update',
            'certificates.read',
        ]}
    >
        {children}
    </ProtectedRoute>
);

// ── Roads / Civils ───────────────────────────────────────────────────────────
export const RoadsProtectedRoute = ({ children }) => (
    <ProtectedRoute
        departments={['MPCU-CV']}
        roles={['roads', 'civils_officer', 'department_head', 'super_admin', 'system_admin']}
        permissions={['roads.read']}
    >
        {children}
    </ProtectedRoute>
);

// ── Accounting ───────────────────────────────────────────────────────────────
export const AccountingProtectedRoute = ({ children }) => (
    <ProtectedRoute
        departments={['MPCU-ACC']}
        roles={['accounting_officer', 'department_head', 'super_admin', 'system_admin']}
        permissions={[
            'financial_records.read',
            'certificates.review_accounting',
            'certificates.approve_accounting',
        ]}
    >
        {children}
    </ProtectedRoute>
);

// ── Procurement ──────────────────────────────────────────────────────────────
export const ProcurementProtectedRoute = ({ children }) => (
    <ProtectedRoute
        departments={['MPCU-PROC']}
        roles={['procurement_officer', 'department_head', 'super_admin', 'system_admin']}
        permissions={[
            'certificates.review_procurement',
            'certificates.approve_procurement',
            'suppliers.read',
            'contractors.read',
        ]}
    >
        {children}
    </ProtectedRoute>
);

// ── Architecture ─────────────────────────────────────────────────────────────
export const ArchitectureProtectedRoute = ({ children }) => (
    <ProtectedRoute
        departments={['MPCU-ARCH']}
        roles={['architect', 'architecture_officer', 'department_head', 'super_admin', 'system_admin']}
        permissions={[
            'projects.create',
            'project_stages.create',
            'projects.read',
            'project_stages.read',
            'project_stages.update',
            'projects.update',
            'reports.read',
        ]}
    >
        {children}
    </ProtectedRoute>
);

// ── Projects (cross-department) ──────────────────────────────────────────────
export const ProjectsProtectedRoute = ({ children }) => (
    <ProtectedRoute
        // No department restriction — multiple depts can access projects
        roles={['project_manager', 'department_head', 'super_admin', 'system_admin']}
        permissions={['projects.read']}
    >
        {children}
    </ProtectedRoute>
);

// ── Reports (cross-department) ───────────────────────────────────────────────
export const ReportsProtectedRoute = ({ children }) => (
    <ProtectedRoute permissions={['reports.read']}>
        {children}
    </ProtectedRoute>
);

// ── Audit Logs ───────────────────────────────────────────────────────────────
export const AuditProtectedRoute = ({ children }) => (
    <ProtectedRoute
        departments={['AC', 'AD']}
        roles={['super_admin', 'system_admin', 'accounting_officer']}
        permissions={['audit_logs.read']}
    >
        {children}
    </ProtectedRoute>
);

// ── Human Resources ──────────────────────────────────────────────────────────
export const HRProtectedRoute = ({ children }) => (
    <ProtectedRoute
        departments={['HR']}
        roles={['hr_officer', 'department_head', 'super_admin', 'system_admin']}
        permissions={['hr.read']}
    >
        {children}
    </ProtectedRoute>
);

// ── Finance ──────────────────────────────────────────────────────────────────
export const FinanceProtectedRoute = ({ children }) => (
    <ProtectedRoute
        departments={['FN']}
        roles={['finance_officer', 'department_head', 'super_admin', 'system_admin']}
        permissions={['financial_records.read']}
    >
        {children}
    </ProtectedRoute>
);

// ── Admin-only ───────────────────────────────────────────────────────────────
export const AdminProtectedRoute = ({ children, permissions = [] }) => (
    <ProtectedRoute
        roles={['super_admin', 'system_admin']}
        permissions={permissions}
    >
        {children}
    </ProtectedRoute>
);